module.exports = __webpack_public_path__ + "img/01sy.23f066d8.svg";